module.exports = __webpack_public_path__ + "static/media/logo-bi.ee16c7b8.png";